import React, { FunctionComponent, memo } from 'react';
import { Box, Grid } from '@material-ui/core';
import { useRemoveSelectedFeature } from '../../../../../../../../hooks/features/useRemoveSelectedFeature';
import SelectedOptionTitle from '../../../../customiseOptions/customiseOptionTitle/ColorOptionTitle';
import SelectedFeaturePrice from '../../../../../summary/summaryAdditionalSelections/selectedFeatures/selectedFeaturePrice/SelectedFeaturePrice';
import RemoveSelectedOptionLink from '../../../../../summary/summaryAdditionalSelections/selectedFeatures/selectedFeatureAction/RemoveSelectedOptionLink';
import IFeature from '../../../../../../../../model/IFeature';
import summaryStyles from '../../../../../summary/summarySection/SummaryStyles';

export interface ISelectedAccessoryOptionProps {
  feature: IFeature;
}

const SelectedAccessoryOption: FunctionComponent<ISelectedAccessoryOptionProps> = memo(({ feature }) => {
  const styles = summaryStyles();

  const { removeSelectedFeature } = useRemoveSelectedFeature();

  return (
    <Box className={styles.selectedOptionContainer}>
      <Grid container={true} className={styles.selectedOptionTitlePrice}>
        <SelectedOptionTitle title={feature.name} isSummary={true} featureId={feature.code} />
        <SelectedFeaturePrice feature={feature} />
      </Grid>
      <RemoveSelectedOptionLink onClick={() => removeSelectedFeature(feature.code)} optionCode={feature.code} />
    </Box>
  );
});

export default SelectedAccessoryOption;
